import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { useMobileTableLabels } from "@/lib/useMobileTableLabels";
import { useEffect } from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { BadgeProvider, useBadges } from "@/context/BadgeContext";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";

function RouteRefresher() {
  const { refresh } = useBadges();
  const loc = useLocation();
  useEffect(() => { refresh(); }, [loc.pathname, refresh]);
  return null;
}

export default function AppShell() {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  useMobileTableLabels(location.pathname);
  return (
    <BadgeProvider>
      <RouteRefresher />
      <div className="min-h-screen flex">
        <div className="hidden md:block sticky top-0 h-screen z-40"><Sidebar collapsed={collapsed} /></div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent side="left" className="p-0 w-[260px]"><Sidebar onNavigate={() => setOpen(false)} /></SheetContent>
        </Sheet>
        <div className="flex-1 min-w-0 flex flex-col">
          <Header onMenu={() => setOpen(true)} collapsed={collapsed} onCollapse={() => setCollapsed((c) => !c)} />
          <main className="flex-1 px-4 sm:px-6 lg:px-10 py-8 max-w-[1400px] w-full"><Breadcrumbs /><Outlet /></main>
        </div>
      </div>
    </BadgeProvider>
  );
}
